import { NavMenuProps } from "@components/UnknownNavBar";

export const productList: NavMenuProps[] = [
    {
        featureTitle: "Get Started",
        feature: [
            {
                title: "WhatsApp Business API",
                link: "/whatsapp-business-api",
                summary: "Manage customers conversations across their lifecycle",
            },
            {
                title: "WhatsApp automation tool",
                link: "/whatsapp-automation",
                summary: "Build drag-and-drop workflows and auto-replies",
            },
            {
                title: "WhatsApp marketing software",
                link: "/whatsapp-marketing",
                summary: "Qualify and engage leads with campaign builders",
            },
            {
                title: "WhatsApp Business API pricing calculator ",
                link: "/whatsapp-conversation-pricing-calculator",
                summary: "Evaluate your WhatsApp API needs and pricing",
            },
        ],
    },
    {
        featureTitle: "Capture leads",
        feature: [
            {
                title: "Click-to-WhatsApp ads",
                link: "/click-to-whatsapp-ads",
                imgAlt: "whatsapp-ads",
                summary: "Turn Meta clicks to leads",
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/whatsapp-ads.png",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-qr-code.png",
                imgAlt: "wa-qr-code",
                title: "WhatsApp QR code",
                link: "/whatsapp-qr-code-generator",
                summary: "Generate WhatsApp QR codes",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-link-generator.png",
                imgAlt: "wa-link-generator",
                title: "WhatsApp link generator",
                link: "/whatsapp-link-generator",
                summary: "Create links to connect with customers",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-chat-widget.png",
                imgAlt: "wa-chat-widget",
                title: "WhatsApp chat widget",
                link: "/whatsapp-chat-button",
                summary: "Add chat button to connect with visitors",
            },
        ],
    },
    {
        featureTitle: "Qualify leads",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-ai-template.png",
                imgAlt: "wa-ai-template",
                title: "WhatsApp Chatbots",
                link: "/whatsapp-chatbot",
                summary: "Automate conversations at scale",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/whatsapp-flows.png",
                imgAlt: "whatsapp-flow",
                title: "WhatsApp Flows",
                link: "/whatsapp-flows",
                summary: "Collect user info using forms",
            },
        ],
    },
    {
        featureTitle: "Nurture Leads",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-broadcast.png",
                imgAlt: "wa-broadcast",
                title: "WhatsApp Broadcast",
                link: "/whatsapp-broadcast",
                summary: "Scale one-to-many campaigns",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-drip-marketing.png",
                imgAlt: "wa-drip-marketing",
                title: "WhatsApp Drip Marketing",
                link: "/whatsapp-drip-marketing",
                summary: "Automate sequence messages",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-ai-template.png",
                imgAlt: "wa-ai-template",
                title: "WhatsApp AI template generator",
                link: "/ai-whatsapp-template-generator",
                summary: "Create WhatsApp templates with prompts",
            },
        ],
    },
    {
        featureTitle: "Close Deals",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-shared-team.png",
                imgAlt: "wa-shared-team",
                title: "WhatsApp Shared Team Inbox",
                link: "/whatsapp-shared-inbox",
                summary: "Collaborate seamlessly with team members",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/product/wa-payment.png",
                imgAlt: "wa-payment.png",
                title: "WhatsApp Payments",
                link: "/whatsapp-payments",
                summary: "Enable one-click payments on WhatsApp",
            },
        ],
    },
];

export const solutionList: NavMenuProps[] = [
    {
        featureTitle: "Industry",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/education.png",
                imgAlt: "education",
                title: "Education",
                link: "/industry/education/whatsapp",
                summary: "Put admissions on autopilot",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/real-estate.svg",
                imgAlt: "real-estate",
                title: "Real Estate",
                link: "/industry/real-estate/whatsapp",
                summary: "Recommend and promote property listings",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/travel.png",
                imgAlt: "travel",
                title: "Travel",
                link: "/industry/travel/whatsapp",
                summary: "Automate hotel and transportation bookings",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/finance.svg",
                imgAlt: "finance",
                title: "Finance",
                link: "/industry/finance/whatsapp",
                summary: "Enable transaction and payment alerts",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/healthcare.svg",
                imgAlt: "healthcare",
                title: "Healthcare",
                link: "/industry/healthcare/whatsapp",
                summary: "Schedule doctor appointments in seconds",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/professional.png",
                imgAlt: "professional",
                title: "Professional Services",
                link: "/industry/professional-services/whatsapp",
                summary: "Manage client appointments and collect docs",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/logistics.png",
                imgAlt: "logistics and shipping",
                title: "Logistics & Shipping",
                link: "/industry/logistics-transportation/whatsapp",
                summary: "Track shipments and update customers instantly",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/food-beverage.png",
                imgAlt: "food and beverages",
                title: "Food & Beverages",
                link: "/industry/food-beverage/whatsapp",
                summary: "Simplify orders and manage reservations",
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/automative.svg",
                imgAlt: "ecommerce",
                title: "Automotive",
                link: "/industry/automotive/whatsapp",
                summary: "Drive test bookings, service reminders, and follow-ups",
            },

            // { image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/automative.svg, title: "Automotive", link: "", summary: "Get all service bookings done in a jiffy" },

            // { image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/government.svg", title: "Government", link: "", summary: "Share citizen information and updates" },

            // { image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/logistics.png", title: "Logistics", link: "", summary: "Automate shipment tracking and updates" },
            // {
            //     image: "https://assets.gallabox.com/gb-home/new-landing/new-header/solution/marketing-agency.png",
            //     title: "Marketing Agency",
            //     link: "/solutions/marketing-teams",
            //     summary: "Boost client revenues with WhatsApp marketing",
            // },
        ],
    },
    {
        featureTitle: "Team",
        feature: [
            {
                title: "Sales",
                link: "/solutions/sales-team",
                summary: "Nurture leads, close deals, enable repeat business",
            },
            { title: "Marketing", link: "/solutions/marketing-teams", summary: "Capture leads, personalize campaigns at scale" },
            { title: "Customer Support", link: "/solutions/customer-support", summary: "Respond to inquiries instantly reducing manual effort" },
        ],
    },
    {
        featureTitle: "Business Type",
        feature: [
            {
                title: "SMB",
                link: "/solutions/small-medium-business",
                summary: "Automate and scale conversations without extra resources",
            },
            { title: "Enterprise", link: "/solutions/enterprise", summary: "Streamline your sales, marketing and support workflows" },
        ],
    },
];

export const integrationList: NavMenuProps[] = [
    {
        featureTitle: "INTEGRATIONS",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/zoho.png",
                imgAlt: "zoho",
                title: "Zoho",
                link: "/whatsapp-integrations/zoho",
                summary: "Turn Zoho prospects to customers",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/facebook-lead.png",
                imgAlt: "facebook-lead",
                title: "Facebook lead form",
                link: "/whatsapp-integrations/facebook-leads-to-whatsapp",
                summary: "Instantly message and convert new Facebook leads on WhatsApp.",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/leadsquared.png",
                imgAlt: "leadsquared",
                title: "Leadsquared",
                link: "/whatsapp-integrations/lead-squared",
                summary: "Nurture Leadsquared leads to drive sales on WhatsApp",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/hubspot.png",
                imgAlt: "hubspot",
                title: "Hubspot",
                link: "/whatsapp-integrations/hubspot",
                summary: "Engage and convert Hubspot leads",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/moengage.png",
                imgAlt: "moengage",
                title: "Moengage",
                link: "/whatsapp-integrations/moengage",
                summary: "Nurture Leadsquared leads to drive sales",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zohobooking.png",
                imgAlt: "pillar-zohobooking",
                title: "Zoho Books",
                link: "/whatsapp-integrations/zoho-books",
                summary: "Connect with Zoho Books to streamline accounting and reduce manual work",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-shopify.png",
                imgAlt: "pillar-shopify",
                title: "Shopify",
                link: "/whatsapp-integrations/shopify",
                summary: "Send abandoned cart and order notifications to customers on WhatsApp.",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/razorpay.png",
                imgAlt: "razorpay",
                title: "Razorpay",
                link: "/whatsapp-integrations/razorpay",
                summary: "Make payments easy on WhatsApp with Razorpay",
                height: 64,
                width: 64,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/integrations/webengage.png",
                imgAlt: "webengage",
                title: "Webengage",
                link: "/whatsapp-integrations/webengage",
                summary: "Engage and retain users with WhatsApp flows from WebEngage",
                height: 64,
                width: 64,
            },
        ],
    },
];

export const knowledgeHubList: NavMenuProps[] = [
    {
        featureTitle: "Blogs",
        feature: [
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/buyer-guide.png",
                imgAlt: "buyer-guide",
                link: "/blog/whatsapp-marketing-software",
                summary: "Top 10 WhatsApp Marketing Software for Effective Campaigns",
                height: 120,
                width: 120,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/complete-guide.png",
                imgAlt: "complete-guide",
                link: "/blog/whatsapp-flow",
                summary: "A complete guide on Whatsapp flows",
                height: 120,
                width: 120,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/whatsapp-tools.png",
                imgAlt: "whatsapp-tools",
                link: "/blog/whatsapp-tools",
                summary: "Top 15 WhatsApp tools every business needs in 2025",
                height: 120,
                width: 120,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/customer-service.png",
                imgAlt: "customer-service",
                link: "/blog/whatsapp-for-customer-service",
                summary: "How WhatsApp for customer service enhances support?",
                height: 120,
                width: 120,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/wa-schedule-message.png",
                imgAlt: "customer-service",
                link: "https://gallabox.com/blog/whatsapp-chatbot",
                summary: "A complete guide on Whatsapp Chatbot",
                height: 120,
                width: 120,
            },
            {
                image: "https://assets.gallabox.com/gb-home/new-landing/new-header/knowledge/head-navrhar.png",
                imgAlt: "customer-service",
                link: "https://gallabox.com/blog/whatsapp-schedule-message",
                summary: "How to schedule WhatsApp message?",
                height: 120,
                width: 120,
            },
        ],
    },
    {
        featureTitle: "OTHER RESOURCES",
        feature: [
            {
                title: "Docs",
                link: "https://docs.gallabox.com/?_gl=1*z8jqq4*_gcl_au*NzA4MzAzMDYuMTczNjE1NDIxMA..*_ga*Njc1MjM5ODMwLjE3MzYxNTQyMTM.*_ga_Q6HGN6FMF5*MTc0MjIxNTY0Ny4xNTEuMS4xNzQyMjE2NTAyLjU1LjAuMA..",
            },
            {
                title: "Bot Templates",
                link: "/whatsapp-chatbot-templates",
            },
            { title: "Case Studies", link: "/case-study" },
            { title: "Ebooks", link: "/resources/downloadables" },
            {
                title: "How to Guides",
                link: "https://guides.gallabox.com/?_gl=1*12ilqy2*_gcl_au*NzA4MzAzMDYuMTczNjE1NDIxMA..*_ga*Njc1MjM5ODMwLjE3MzYxNTQyMTM.*_ga_Q6HGN6FMF5*MTc0MjIxNTY0Ny4xNTEuMS4xNzQyMjE2NTAyLjU1LjAuMA..",
            },
            { title: "Message Templates", link: "/resources/free-whatsapp-message-templates" },
            { title: "Alternatives", link: "/alternatives" },
            { title: "Agencies", link: "/agencies" },
            { title: "News", link: "/news" },
            { title: "Webinars", link: "/webinars" },
        ],
    },
];

export const partnerList: NavMenuProps[] = [
    {
        featureTitle: "LET'S TEAM UP",
        feature: [
            {
                title: "Become a Partner",
                link: "/gallabox-partner-program",
                imgAlt: "Reseller",
                summary: "Amplify your earning potential with Gallabox",
                image: "/nav-icons/Reseller.svg",
            },
            {
                image: "/nav-icons/Partner.svg",
                imgAlt: "Partner",
                title: "Become an Affiliate",
                link: "/affiliate-partner-program",
                summary: "Grow your income through strategic connections",
            },
        ],
    },
];
